<ng-container *ngIf="scrollContainer">
  <nav
    #sidenav
    class="sidenav"
    [ngClass]="{ show: !hidden, 'sidenav-slim': slim && slimCollapsed }"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </nav>
</ng-container>

<ng-container *ngIf="!scrollContainer">
  <nav
    #sidenav
    class="sidenav"
    mdbScrollbar
    [ngClass]="{ show: !hidden, 'sidenav-slim': slim && slimCollapsed }"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </nav>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
